export function mutable<V>(value: readonly V[]): V[]
export function mutable<T>(value: Readonly<T>): T
export function mutable<T>(value: unknown): unknown {
  return value
}
